import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Spinner from "../layout/Spinner";
import { compress } from "../utils/compress";
import { updateMatch, updateSensorData } from "../utils/dbutils";

const CATAPULT_API_URL = process.env.REACT_APP_CATAPULT_API_URL;

function CatapultSessions() {
  const location = useLocation();
  const { match, team } = location.state;
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("Loading...");
  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  //   const token =
  //     "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6IjEzMWY5NGIxOTg3ZGY4NzcxNTljOGQ2MTAzMTIzNDNjIn0.eyJhdWQiOiJhZDMxNzI5Yy05OWYwLTQyM2MtYThhOC0wYTExYjU3MWU2Y2EiLCJqdGkiOiJlNWU5NGZjMzFkYjE2NGY4MWU5MzYzODhjYjQ4YzJlM2ZhMzEwZDkzYmU1NGUyNTUyY2ZkMmZlNjIxZGMxOWZiOGM2ZjZkMDRkODQxZGE2YiIsImlhdCI6MTc0NzA5MjMyMi42OTU0MzksIm5iZiI6MTc0NzA5MjMyMi42OTU0NDIsImV4cCI6NDkwMDY5MjMyMi42ODYwOTIsInN1YiI6IjQ2MmRkNmEyLWUzMjMtNDBmYS04ZDM2LTNjZjc2MGY0MGM0YyIsInNjb3BlcyI6WyJjb25uZWN0IiwiY2F0YXB1bHRyIiwic2Vuc29yLXJlYWQtb25seSJdLCJpc3MiOiJodHRwczovL2JhY2tlbmQtYXUub3BlbmZpZWxkLmNhdGFwdWx0c3BvcnRzLmNvbSIsImNvbS5jYXRhcHVsdHNwb3J0cyI6eyJvcGVuZmllbGQiOnsiY3VzdG9tZXJzIjpbeyJyZWxhdGlvbiI6ImF1dGgiLCJpZCI6OTAxfV19fX0.muBO-jv0a7sAOjskGE74rZOXO_OdtpiSYW_0NfP_nXG7Dapv3uGL81Msc3JZ2iFuDwddVsd_HAV6nH5qZoUGc2qBILCptDQnz0aesdYszl1fsbFeO2JUtKBABYFE1AWKq_54LL1BIhqYlrJoww72v_wQzIqXgRtZDKsQUizGdSWtvxEm57qLscbncERriPVLE_szWG-Bdkvmm18TutT8LsTPp-lhfevJRmfkCVWHTft7O6bv244b3124WcIRTcyRmQt-mkJMYmLormB7y02dJhj2rsSp4DfsF0YXplGei_j_u1Qxx2ffCYPvebkRcxga_3o2aKchJuUrHiF-JylKZYSVJLJSb4ITv1xDuWUInIb1aVOYROkrfT8J-4bPB9m0n0cPRYz8e1p3vFw3JRg_VqqfQQ8lgIJBg244YxheX85MDnuGnQcYYe-DBwK9WpVieb-WML_2uTmEwZrj2ANZUuypnN_DbpNMDUuou_n_E-c-iaOXAsNdcVNjbbiCbcPBKztjFpNCSuCX7FYXXlQy1D_ZJ1B7ukIS-wXzCRWuDixf-BBF0AoAB-CWoMesCJwicLiaeEBHorXeTBpAQJl1VsrJcCmTdTD-LRPri0xusZUy5uGqkPgA96dIEmfKLHikB5h6-umTV0cuTYJaWp5HZYh7GSKNlsi4QyTjty499dY";

  const tokens = {
    "Geelong Cats": process.env.REACT_APP_GEELONG_CATAPULT_TOKEN,
    "Port Adelaide": process.env.REACT_APP_PORTADELAIDE_CATAPULT_TOKEN,
    "AFL Umpires": process.env.REACT_APP_AFL_UMPIRES_CATAPULT_TOKEN,
  };

  const getAthletesInActivity = async (activityId) => {
    const token = tokens[team];
    const options = {
      method: "GET",
      headers: {
        accept: "application/json",
        authorization: `Bearer ${token}`,
      },
    };

    let aths = [];
    await fetch(
      `${CATAPULT_API_URL}/activities/${activityId}/athletes`,
      options
    )
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
        aths = res;
      })
      .catch((err) => {
        console.error(err);
      });
    return aths;
  };

  const getAthleteSessionSensorData = async (activityId, athleteId) => {
    const token = tokens[team];
    const options = {
      method: "GET",
      headers: {
        accept: "application/json",
        authorization: `Bearer ${token}`,
      },
    };

    let sensordata = null;
    await fetch(
      `${CATAPULT_API_URL}/activities/${activityId}/athletes/${athleteId}/sensor`,
      options
    )
      .then((res) => res.json())
      .then((res) => {
        // console.log(res);
        sensordata = res;
      })
      .catch((err) => {
        console.error(err);
      });
    return sensordata;
  };

  const getAthletePeriodSensorData = async (periodId, athleteId) => {
    const token = tokens[team];
    const options = {
      method: "GET",
      headers: {
        accept: "application/json",
        authorization: `Bearer ${token}`,
      },
    };

    let venue = null;
    if (team === "AFL Umpires") {
      venue = match.home_catapult_session.venue;
    } else {
      venue =
        team === match.home_squad
          ? match.home_catapult_session.venue
          : match.away_catapult_session.venue;
    }
    let sensordata = null;
    let url = `${CATAPULT_API_URL}/periods/${periodId}/athletes/${athleteId}/sensor?xy_middle=1&frequency=5`;
    if (selectedSession.alternate_venue) {
      url += `&field_centre_latitude=${selectedSession.alternate_venue.lat}&field_centre_longitude=${selectedSession.alternate_venue.lng}&field_rotation=${selectedSession.alternate_venue.rotation}&field_length=${match.venueLength}&field_width=${match.venueWidth}`;
    } else {
      url += `&field_centre_latitude=${venue.lat}&field_centre_longitude=${venue.lng}&field_rotation=${venue.rotation}&field_length=${match.venueLength}&field_width=${match.venueWidth}`;
    }
    await fetch(url, options)
      .then((res) => res.json())
      .then((res) => {
        // console.log(res);
        sensordata = res;
      })
      .catch((err) => {
        console.error(err);
      });
    return sensordata;
  };

  const doSessionSelected = async (session) => {
    setSelectedSession(session);
    const aths = await getAthletesInActivity(session.id);
    if (team === match.home_squad) {
      match.home_catapult_session = session;
      match.home_athletes = aths;
    } else if (team === match.away_squad) {
      match.away_catapult_session = session;
      match.away_athletes = aths;
    } else if (team === "AFL Umpires") {
      match.umpires_catapult_session = session;
      match.umpires = aths;
    }
    await updateMatch(match);
  };

  const doGetCatapultData = async (session) => {
    console.log(session);
    setLoading(true);
    const aths = await getAthletesInActivity(session.id);
    if (aths) {
      for (var period of session.periods) {
        for (var ath of aths) {
          // console.log(ath);
          setLoadingMessage(
            `Loading ${period.name} sensor data for ${ath.first_name} ${ath.last_name} ...`
          );
          const data = await getAthletePeriodSensorData(period.id, ath.id);
          if (data.status === "error") {
            toast.error(
              `Error: ${data.message} for ${ath.first_name} ${ath.last_name}`
            );
            continue;
          }
          const str = JSON.stringify(data[0]);
          const cdata = compress(str);
          console.log(cdata.length);
          await updateSensorData({
            id: session.id + "_" + period.id + "_" + ath.id,
            activityId: session.id,
            periodId: period.id,
            athleteId: ath.id,
            data: cdata,
            name: ath.first_name + " " + ath.last_name,
          });
        }
      }
    }
    setLoading(false);
  };

  const processSessions = (ss) => {
    const mdate = new Date(match.matchDate);
    const mdatesecs = mdate.getTime() / 1000;
    const mdatesecs24h = mdatesecs + 86400;
    let sss = [];
    for (var s of ss) {
      const st = new Date(s.start_time * 1000);
      //   if (s.tags.includes("Match")) {
      if (s.start_time > mdatesecs && s.start_time < mdatesecs24h) {
        sss.push(s);
      }
      //   }
    }
    setSessions(sss.sort((a, b) => b.start_time - a.start_time));
    setLoading(false);
  };

  const doInit = async () => {
    // let tokens = {};
    // tokens["Geelong Cats"] = process.env.REACT_APP_GEELONG_CATAPULT_TOKEN;
    // tokens["Port Adelaide"] = process.env.REACT_APP_PORTADELAIDE_CATAPULT_TOKEN;
    // console.log(tokens);
    const token = tokens[team];
    setLoading(true);
    const options = {
      method: "GET",
      headers: {
        accept: "application/json",
        authorization: `Bearer ${token}`,
      },
    };

    fetch(`${CATAPULT_API_URL}/activities`, options)
      .then((res) => res.json())
      .then((res) => {
        processSessions(res);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    // Initialize the component
    if (sessions.length === 0) {
      doInit();
    }
  }, [match]);

  const checkVenue = (session) => {
    // if (!match.home_catapult_session || !match.away_catapult_session) {
    //   return <></>;
    // }
    let venueok = true;
    if (
      team === match.away_squad &&
      !match.away_catapult_session?.alternate_venue
    ) {
      if (session.venue.name !== match.home_catapult_session.venue.name) {
        if (!match.home_catapult_session.alternate_venue) {
          venueok = false;
        }
      }
    } else if (
      team === match.home_squad &&
      !match.home_catapult_session?.alternate_venue
    ) {
      if (session?.venue.name !== match.away_catapult_session?.venue.name) {
        if (!match.away_catapult_session?.alternate_venue) {
          venueok = false;
        }
      }
    }
    if (venueok) {
      return <></>;
    } else {
      const othervenue =
        team === match.away_squad
          ? match.home_catapult_session?.venue
          : match.away_catapult_session?.venue;
      return (
        <>
          <p className="text-sm font-bold text-error mt-2">
            Venue mismatch: {session.venue?.name} vs {othervenue?.name}
          </p>
          <button
            className="btn-in-form mt-2"
            onClick={() => {
              session.alternate_venue = othervenue;
              updateMatch(match);
            }}
          >
            Use {othervenue?.name} instead
          </button>
        </>
      );
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-[90vh]">
        <Spinner message={loadingMessage} />
      </div>
    );
  }

  return (
    <>
      <div className="flex gap-2">
        <div className="flex-col h-[90vh] overflow-auto">
          {sessions.map((session, index) => (
            <div
              key={index}
              className="flex flex-col p-2 border-b border-gray-200 cursor-pointer"
              onClick={() => {
                doSessionSelected(session);
              }}
            >
              <h3 className="text-lg font-semibold">{session.name}</h3>
              <p className="text-sm text-gray-500">{session.description}</p>
              <p className="text-sm text-gray-500">
                Date: {new Date(session.start_time * 1000).toLocaleString()}
              </p>
              <p className="text-sm text-gray-500">
                Duration:{" "}
                {((session.end_time - session.start_time) / 60).toFixed(2)}{" "}
                minutes
              </p>
              <p className="text-sm text-gray-500">{session.tags} </p>
            </div>
          ))}
        </div>
        <div className="flex-col">
          {selectedSession && (
            <div className="flex flex-col p-4 border border-gray-200">
              <h3 className="text-lg font-semibold">
                Selected Session: {selectedSession.name}
              </h3>
              <p className="text-sm text-gray-500">
                Date:{" "}
                {new Date(selectedSession.start_time * 1000).toLocaleString()}
              </p>
              <p className="text-sm text-gray-500">
                Duration:{" "}
                {(
                  (selectedSession.end_time - selectedSession.start_time) /
                  60
                ).toFixed(2)}{" "}
                minutes
              </p>
              <p className="text-sm text-gray-500">
                Venue: {selectedSession.venue.name}
              </p>
              {checkVenue(selectedSession)}
              <div className="flex gap-2 mt-10">
                <button
                  className="btn-confirm w-full"
                  onClick={() => doGetCatapultData(selectedSession)}
                >
                  Load Catapult Data
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default CatapultSessions;
